import { Model, attr } from '@elatonsev/js-models';

export default class VendorSettingsModel extends Model {
  booking_locale = attr('string', {defaultValue: 'ru'});
  ya_metrika_id = attr('string');
  is_booking_email_required = attr('boolean', {defaultValue: true});
  is_booking_skip_resource = attr('boolean', {defaultValue: false});
  is_booking_disable_canceling = attr('boolean', {defaultValue: false});
}